










































import { HELPER } from "@/utils/Helper";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { Signie } from "./SigPanel.vue";
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {}
})
export default class LegacyPadComponent extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	// mounted(){}
	// created(){}

	/* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop({default:false})
  public disabled: boolean;

  @Prop({default:false})
  public value: Signie;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  private signa__: Signie = new Signie();

  /* VUE DATA */
  public options = {
    penColor: "white",
    backgroundColor: "rgba(0,0,0,0)",
    onEnd: this.onEnd,
  };



  /* VUE WATCH */
  @Watch("value", {immediate:true})
  onValueChanged(newVal: Signie, oldVal: Signie) {

		if (newVal==null || newVal==undefined)
			newVal = new Signie();

		this.$nextTick(()=>{
			this.SetSignature(HELPER.Clone( newVal));
		});
	}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
  public SetSignature(signa: Signie): void {
		
		if (signa.Std==this.signa__.Std){
				console.log("No changes detected, rejecting update");
				return;
		}

		this.signa__ = signa;

		var signstrStd = '';

		/* WE HAVE A TOPAZ SIGNATURE HERE, AND TOPAZ IS SUPPORTED 
		*/
		{
			if (signa.Std!=null && signa.Std.length>0)
			{
				signstrStd = signa.Std;
			}
		}


		if (signstrStd.length > 0){
      (this.$refs.signaturePad as any).fromDataURL(signstrStd);
		}
	}


  public ClearSignature() {
    (this.$refs.signaturePad as any).clearSignature();
		this.signa__.Std = '';
    this.NotifyChanges();
  }

	public NotifyChanges(){
		console.log(this.signa__);
		this.$emit('input', this.signa__);
		this.$emit('change');
	}

  public onEnd() {
    const { data } = (this.$refs.signaturePad as any).saveSignature();
		this.signa__.Std = data;
		this.NotifyChanges();
  }

}
